import { render, staticRenderFns } from "./shared-office.vue?vue&type=template&id=659ea868"
import script from "./shared-office.vue?vue&type=script&lang=js"
export * from "./shared-office.vue?vue&type=script&lang=js"
import style0 from "./shared-office.vue?vue&type=style&index=0&id=659ea868&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports